var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormTotalSets.jinja');
require('./SubmissionFormTotalSets.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {

    },

    initialize: function (options) {
        this.options = options || {};

        app.utils.timeInputHandler({
            time0: this.$('input[name="setsClockLimited0"]'),
            time1: this.$('input[name="setsClockLimited1"]'),
            time2: this.$('input[name="setsClockLimited2"]')
        });

        app.utils.timeInputHandler({
            time0: this.$('input[name="setsClockNew0"]'),
            time1: this.$('input[name="setsClockNew1"]'),
            time2: this.$('input[name="setsClockNew2"]')
        });

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    checkRequired: function () {
        return SubmissionFormBlock.prototype.checkRequired.call(this);
    },


    getFormData: function () {
        return {
            'setsClockLimited': this.formatPhoneAndTime('setsClockLimited', ':'),
            'setsNew': this.$('select[name="setsNew"]').val(),
            'setsOld': this.$('select[name="setsOld"]').val(),
            'setsClockNew': this.formatPhoneAndTime('setsClockNew', ':')
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormTotalSets.js
// module id = 124
// module chunks = 0